export const mapConfig = {
    linzKey: "d01fbtg0ar2353bfqnrq2tp0de6",
    petoneCoordinates: [-41.2260812, 174.8718105],
    zoom: 14,
    maxZoom: 23,
    refreshFrequency: 5000,
};

export const TASK_PANE_Z_INDEX = 500;